import React, { ReactNode } from 'react';
import styled from 'styled-components';

const MyButton = styled.button<{
  canIconOnly?: boolean;
  disabled?: boolean;
  size?: string;
}>`
  align-items: center;
  background-color: initial;
  background-image: ${(props) =>
    props.disabled
      ? 'linear-gradient(-180deg, #EEEEEE, #CCCCCC)'
      : 'linear-gradient(-180deg, #FF7E31, #E62C03)'};
  border-radius: 6px;
  box-shadow: rgba(0, 0, 0, 0.1) 0 2px 4px;
  color: ${(props) => (props.disabled ? '#666666' : '#FFFFFF')};
  cursor: ${(props) => (props.disabled ? 'default' : 'pointer')};
  display: flex;
  font-family:
    Inter,
    -apple-system,
    system-ui,
    Roboto,
    'Helvetica Neue',
    Arial,
    sans-serif;
  gap: 8px;
  height: ${(props) =>
    props.size === 'large' ? '40px' : props.size === 'small' ? '24px' : '32px'};
  justify-content: center;
  line-height: ${(props) =>
    props.size === 'large' ? '40px' : props.size === 'small' ? '24px' : '32px'};
  outline: 0;
  overflow: hidden;
  padding: 0 20px;
  pointer-events: auto;
  position: relative;
  text-align: center;
  touch-action: manipulation;
  user-select: none;
  -webkit-user-select: none;
  vertical-align: top;
  white-space: nowrap;
  width: ${(props) =>
    props.size === 'large'
      ? '200px'
      : props.size === 'small'
        ? '80px'
        : '120px'};
  z-index: 9;
  border: 0;
  transition: box-shadow 0.2s;
  @media screen and (max-width: 900px) {
    width: ${(props) =>
      props.canIconOnly
        ? props.size === 'large'
          ? '40px'
          : props.size === 'small'
            ? '24px'
            : '32px'
        : props.size === 'large'
          ? '200px'
          : props.size === 'small'
            ? '80px'
            : '120px'};
  }

  :hover {
    box-shadow: ${(props) =>
      props.disabled ? 'none' : 'rgba(253, 76, 0, 0.5) 0 3px 8px'};
  }
`;

type ButtonProps = {
  canIconOnly?: boolean;
  children?: ReactNode;
  disabled?: boolean;
  icon?: string;
  onClick?: (e: React.MouseEvent<HTMLElement>) => void;
  size?: 'small' | 'medium' | 'large';
};

const Button = ({
  canIconOnly = false,
  children,
  disabled = false,
  icon,
  onClick,
  size = 'medium',
}: ButtonProps) => {
  return (
    <MyButton
      canIconOnly={canIconOnly}
      disabled={disabled}
      onClick={onClick}
      size={size}
    >
      {icon && (
        <img
          alt="button icon"
          src={`/icons/${icon}.svg`}
          height="16px"
          width="16px"
          style={{ filter: 'invert(1)' }}
        />
      )}
      {children}
    </MyButton>
  );
};

export default Button;
